<template>
  <v-card
    flat
    outlined
    class="pa-4"
  >
    <v-card-title class="subtitle-1 primary--text pa-0 ma-0">
      <span>{{ titulo.toUpperCase() }}</span>
    </v-card-title>
    <v-card-text class="pa-0 ma-0">
      <v-data-table
        :items="[value]"
        :headers="value.headers"
        hide-default-footer
      />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'Resumo',

  props: {
    titulo: {
      type: String,
      required: true,
    },
    value: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
};
</script>
